import { getRBACPermissions } from '~/permissions/rbac/getRBACPermissions';
import { pilot } from '~/services/serviceInstances';

export async function getCurrentUser() {
  const user = await pilot.get('user/my-profile/');
  if (user.role_uuid?.role_type) {
    const rbacPermissions = getRBACPermissions(
      user.role_uuid?.permissions || [],
    );
    return { ...user, ...rbacPermissions };
  } else {
    return user;
  }
}

export async function setUserFoldersPermission() {
  return pilot.get('user/status/onboarding/');
}
